import { AxiosInstance } from 'axios';
import TokenService from '../../services/TokenService';
import api from '../api/api';
import Token from '../../models/Token';
import UserService from '../../services/UserService';

const errorInterceptor = (axiosInstance: AxiosInstance): void => {
  const interceptor = axiosInstance.interceptors.response.use(
    (response) => Promise.resolve(response),
    async (error) => {
      if (error.response.status) {
        switch (error.response.status) {
          case 401: {
            api.interceptors.response.eject(interceptor);

            const tokens: Token | null = TokenService.getToken();
            if (!tokens) {
              return Promise.reject(error.response);
            }

            try {
              const userService = new UserService();
              const data: Token = await userService.refreshToken(tokens);

              TokenService.setToken(data);

              error.config.headers.Authorization = `Bearer ${data.accessToken}`;
              return api(error.response.config);
            } catch (err: unknown) {
              TokenService.removeToken();
              return Promise.reject(err);
            }
          }
          default:
            return Promise.reject(error.response);
        }
      }

      return false;
    }
  );
};

export default errorInterceptor;
